import type { Client } from '@stomp/stompjs';
import { createContext, FC, ReactNode, useContext } from 'react';
import useSocket from '../../hooks/useSocket';

export interface ISocketContext {
  loading: boolean;
  connected: boolean;
  client: Client | null;
  error?: string;
  connectionMsg: string;
  reconnect: () => void;
  retrying: boolean;
}
interface SocketCtxProps {
  children: ReactNode;
  task_sid: string;
  messaging_service_key: string;
  captchaToken?: string;
  queue_sid: string;
}

export const SocketContext = createContext<ISocketContext>({ loading: false, client: null, connected: false, error: '', connectionMsg: '', reconnect: () => {}, retrying: false });
export const useSocketCtx = (): ISocketContext => useContext(SocketContext);
export const SocketProvider: FC<SocketCtxProps> = ({ children, task_sid, messaging_service_key, captchaToken, queue_sid }) => {
  const { loading, client, connected, error, connectionMsg, reconnect, retrying } = useSocket(task_sid, messaging_service_key, captchaToken, queue_sid);
  return <SocketContext.Provider value={{ loading, client, connected, connectionMsg, error, reconnect, retrying }}>{children}</SocketContext.Provider>;
};
